import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
        <path
          transform="translate(-2.990000, 0.000000)"
          d="M38.8691 63V51.9463L28.5742 33.4072H35.2598L41.9043 46.04H42.0479L48.6719 33.4072H55.3779L45.0625 51.9463V63H38.8691Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);

export default IconLogo;
